import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { useNotificationStore } from '../../components/notificationStore';
import { useUserStore } from '../../components/userStore';
import ConfigurationForm from './components/Form';

const Configuration = () => {
	const { user } = useUserStore();
	const { serviceId } = useParams();
	const navigate = useNavigate();
	const queryClient = useQueryClient();
	const { showSuccess, showError } = useNotificationStore();
	const exServ = useQuery({
		queryKey: ['external-service', user.coord_agency.id, serviceId],
		queryFn: async () => {
			const { data } = await axios.get(
				`/coord_agencies/${user.coord_agency.id}/external-services/${serviceId}`,
			);
			return data;
		},
		initialData: () =>
			queryClient
				.getQueryData(['externalServicesList', user.coord_agency.id])
				?.find(({ id }) => id == serviceId),
	});
	const requiredServiceForms = useQuery({
		queryKey: ['required-service-forms'],
		queryFn: async () => {
			const { data } = await axios.get('/care_quest_groups', {
				params: {
					filter: JSON.stringify({
						where: {
							questionnaire_type: 'care_questionnaire',
							or: [
								{
									inactive_ind: false,
								},
								{
									inactive_ind: null,
								},
							],
						},
						order: 'name',
					}),
				},
			});
			return data;
		},
	});

	const handleFormSubmit = async (data) => {
		try {
			await axios.post(
				`/coord_agencies/${user.coord_agency.id}/external-services/${serviceId}`,
				{
					...data,
					// taxonomyStatus: Object.entries(data.taxonomyStatus).reduce(
					// 	(acc, [key, value]) => {
					// 		acc.push(value);
					// 		return acc;
					// 	},
					// 	[],
					// ),
					serviceForms: data.serviceForms
						.filter((service) => service.value)
						.map((service) => ({
							formId: service.id,
							taxonomyId: service.taxonomy_id,
						})),
				},
			);
			showSuccess('Service updated');
			queryClient.invalidateQueries({
				queryKey: ['externalServicesList', user.coord_agency.id],
			});
			queryClient.invalidateQueries({
				queryKey: ['external-service', user.coord_agency.id, serviceId],
			});
			navigate('/services');
		} catch (err) {
			showError('Unable to update service. Please try again.');
		}
	};

	let exServData;
	if (exServ.isFetched && exServ?.data) {
		exServData = JSON.parse(exServ.data.data);
	}

	return (
		<>
			<h1>Service Configuration Builder</h1>
			<div className="clear-both px-4 py-4 mt-4 bg-white rounded-lg sm:px-6 lg:px-8">
				{(exServ.isFetching || requiredServiceForms.isFetching) && (
					<div>
						<span className="loading loading-spinner text-primary" />
					</div>
				)}
				{exServ.isFetched && requiredServiceForms.isFetched && (
					<ConfigurationForm
						externalService={exServ.data}
						requiredServiceForms={requiredServiceForms.data}
						exServData={exServData}
						// isFetching={exServ.isFetching || requiredServiceForms.isFetching}
						onFormSubmit={handleFormSubmit}
					/>
				)}
			</div>
		</>
	);
};

export default Configuration;
